// extracted by mini-css-extract-plugin
export var closeButton = "_gm-2";
export var closeButtonIcon = "_gm-3";
export var lightboxContent = "_gm-1";
export var lightboxOverlay = "_gm-0";